import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { State } from 'src/app/enums/state.enum';
import { BusinessEntityResource } from 'src/app/interfaces/business-entity-resource';
import { BusinessEntityService } from 'src/app/services/business-entity.service';
import { EnvironmentService } from 'src/app/services/environment.service';
import { BusinessUserResource } from 'src/app/interfaces/business-user-resource';
import { MatSelectChange } from '@angular/material/select';
import { OverlayService } from 'src/app/services/overlay.service';
import * as uuid from 'uuid';
/**
 * The Options used for sorting
 */
interface SortOption {
  /**
   * The Value of the Filteroption
   */
  value: string;
  /**
   * The viewValue (visible to the User) of the Filteroption
   */
  viewValue: string;
  /**
   * Is the  Filteroption disabled
   */
  state?: boolean;
}
/**
 * The Coordinates
 */
var coords = { lat: "", lon: "" };
@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponentBusinessentity implements OnInit {
  addForm: UntypedFormGroup;
  businessuserForm: UntypedFormGroup;
  files: File[] = [];
  loadingLocation: boolean = false;
  loadedLocation: boolean = false;


  public sortOptions: SortOption[] = [
    { value: 'EVENT_PARTNER', viewValue: 'Aktionspartner' },
    { value: 'SERVICE_CENTER', viewValue: 'Service-Einheit' },
  ];

  public contactChannelOptions: SortOption[] = [
    { value: 'EMAIL', viewValue: 'Mail', state: false },
    { value: 'PHONE_PRIVATE', viewValue: 'Telefon', state: false },
    { value: 'PHONE_MOBILE', viewValue: 'Telefon (Mobil)', state: false },
    { value: 'FAX', viewValue: 'Fax', state: false },
    { value: 'WEBSITE', viewValue: 'Webseite', state: false },
    { value: 'UNKNOWN', viewValue: 'Andere', state: false },
  ];

  public genderOptions: SortOption[] = [
    { value: 'MALE', viewValue: 'Herr' },
    { value: 'FEMALE', viewValue: 'Frau' },
    { value: 'UNDEFINED', viewValue: 'Divers' },
  ]



  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private dialog: MatDialog,
    private businessEntityService: BusinessEntityService,
    private environmentService: EnvironmentService,
    private overlayService: OverlayService) {
    this.addForm = this.fb.group({
      publicId: [uuid.v4(), []],
      image: ['', [Validators.required]],
      name: ['', [Validators.required]],
      businessRole: ['EVENT_PARTNER', []],
      description: ['', []],
      state: ['', []],
      openingHours: this.fb.array([]),
      contactChannels: this.fb.array([]),
      address: this.fb.group({
        street: ['', []],
        postcode: ['', []],
        city: ['', []],
        countryCode: ['DE', []],
        location: this.fb.group({
          lat: ['', []],
          lng: ['', []],
        })
      }),
      members: this.fb.array([])
    });


  }

  ngOnInit(): void {
    //  this.addOpeningHours();
    //  this.addContactChannels();
    //  this.addMember();
  }

  onSelect(event) {
    this.files.push(...event.addedFiles);
    this.addForm.controls["image"].setValue(this.files[0])
  }


  onRemove(event) {
    console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }

  createPartner() {
    console.log(this.addForm)

    this.addForm.markAllAsTouched();

    if (this.addForm.invalid) {
      return;
    }

    this.addForm.controls.address["controls"].location.patchValue({
      lat: coords.lat,
      lng: coords.lon
    })
    let tempOpening = [];

    if (this.addForm.getRawValue().openingHours.length > 0) {
    this.addForm.value.openingHours.forEach(element => {
      tempOpening.push(element.name)
    });
  }

    let tempBusinessentity: BusinessEntityResource = {
      publicId: this.addForm.value.publicId,
      name: this.addForm.value.name,
      address: this.addForm.value.address,
      contactChannels: this.addForm.value.contactChannels,
      openingHours: tempOpening,
      businessRole: this.addForm.value.businessRole,
      clientRef: this.environmentService.getClientId(),
      state: State.NEW
    }

    this.businessEntityService.createBusinessentity(tempBusinessentity).subscribe((businessEntityResource: BusinessEntityResource) => {
      if (businessEntityResource.publicId != null) {
        //Upload logo to new BusinessEntity
        this.businessEntityService.addLogo(businessEntityResource.publicId, this.files[0]).subscribe(logo => {
          console.log("LOGO: ", logo)
        })

        if (this.addForm.getRawValue().contactChannels.length > 0) {
          //Add ContactChannel to new BusinessEntity
          this.addForm.value.contactChannels.forEach(element => {
            this.businessEntityService.addContactChannel(businessEntityResource.publicId, element).subscribe(channel => {
              console.log("Channel: ", channel)
            })
          });
        }

        if (this.addForm.getRawValue().members.length > 0) {
          this.businessEntityService.createAnonMember().subscribe(anon => {
            let tempUser: BusinessUserResource = anon;
            tempUser.person = this.addForm.controls.members.value[0].person;
            tempUser.address = this.addForm.controls.members.value[0].address;
            tempUser.email = this.addForm.controls.members.value[0].email;
            tempUser.phone = this.addForm.controls.members.value[0].phone;

            console.log("ANon: ", tempUser)
            this.businessEntityService.updateAnonMember(tempUser).subscribe(value => {
              console.log("UPDATE: ", value)
              this.businessEntityService.addMember(businessEntityResource.publicId, value).subscribe(valueFromADD => {
                console.log("valueFromADD", valueFromADD)
              })
            })
          })
        }
        this.overlayService.openSnackBar("Partner erfolgreich angelegt!");
        this.router.navigateByUrl('caseworker/businessentity')
      }
    })

  }

  movebacktoOverview() {
    this.router.navigateByUrl('caseworker/businessentity')
  }


  get openingHours() {
    return this.addForm.controls["openingHours"] as UntypedFormArray;
  }
  addOpeningHours() {
    const openingForm = this.fb.group({
      name: ['', Validators.required],
    });

    this.openingHours.push(openingForm);
  }

  deleteOpeningHours(lessonIndex: number) {
    this.openingHours.removeAt(lessonIndex);
  }


  get contactChannels() {
    return this.addForm.controls["contactChannels"] as UntypedFormArray;
  }
  addContactChannels() {
    const contactChannelForm = this.fb.group({
      channelType: ['EMAIL', Validators.required],
      channelData: ['', Validators.required],
      channelState: ['NEW', Validators.required],
    });

    this.contactChannels.push(contactChannelForm);
  }

  deletContactChannels(lessonIndex: number) {
    this.contactChannelOptions.forEach(element => {
      if (element.value == this.contactChannels.value[lessonIndex].channelType) {
        element.state = false;
      }
    });

    this.contactChannels.removeAt(lessonIndex);
  }


  get members() {
    return this.addForm.controls["members"] as UntypedFormArray;
  }
  addMember() {
    const memberForm = this.fb.group({
      mobile: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      account: this.fb.group({
        username: ['', []],
        role: this.fb.group({
          name: ['', []],
        })
      }),
      person: this.fb.group({
        gender: ['', [Validators.required]],
        birthday: ['', [Validators.required]],
        firstName: ['', [Validators.required]],
        lastName: ['', [Validators.required]],
        title: ['', []],
      }),
      address: this.fb.group({
        street: ['', [Validators.required, Validators.pattern(/^([\S\s]+?)\s+([\d-]*)\s*([\w])?$/)]],
        postcode: ['', [Validators.required, Validators.maxLength(5), Validators.minLength(5), Validators.pattern(/^[0-9]\d*$/)]],
        city: ['', [Validators.required]],
        countryCode: ['DE', []],
        location: this.fb.group({
          lat: ['', []],
          lng: ['', []],
        })
      })
    });

    this.members.push(memberForm);
  }

  deletMembers(lessonIndex: number) {
    this.members.removeAt(lessonIndex);
  }



  getPositions() {
    this.loadingLocation = true;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {

        this.showPosition(position)
      });
    } else {
      this.loadingLocation = false;
      //browser does not support geolocation
    }

  }

  showPosition(position) {
    this.loadingLocation = false;
    this.loadedLocation = true;
    coords.lat = position.coords.latitude;
    coords.lon = position.coords.longitude;
  }

  changeAvalibleContactChannels(event: MatSelectChange) {
    this.contactChannelOptions.forEach(element => {
      if (element.value == event.value) {
        element.state = true;
      }
    });
  }

}
